var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import qs from "qs";
import { createBrowserHistory, createMemoryHistory } from "history";
export var history = process.env.NODE_ENV === "test" ? createMemoryHistory() : createBrowserHistory();
/**
 * Gets  the current window location hash
 */

export function getLocationHash() {
  return window.location.hash.split("#")[1] || "";
}
/**
 * Checks to see if we have a specific hash key in our window.location
 *
 * @param {String} hashKey
 */

export function hasLocationHash(hashKey) {
  return getLocationHash() === hashKey;
}
/**
 *  Parses parameters. If none are found, the window location search object is used.
 */

export function getParsedQueryString(params) {
  if (params === void 0) {
    params = window.location.search;
  }

  return qs.parse(params, {
    ignoreQueryPrefix: true
  });
}
/**
 * Removes parameters from the navigation query string and updates the url.
 *
 * @param {Array} paramsToRemove
 */

export function getCurrentUrl(_a) {
  var _b = _a.paramsToRemove,
      paramsToRemove = _b === void 0 ? [] : _b;
  var parsedQueryString = getParsedQueryString();
  var filteredParams = Object.entries(parsedQueryString).reduce(function (filteredParams, _a) {
    var _b;

    var key = _a[0],
        value = _a[1];
    if (paramsToRemove.includes(key)) return filteredParams;
    return __assign(__assign({}, filteredParams), (_b = {}, _b[key] = value, _b));
  }, {});
  return [window.location.pathname, qs.stringify(filteredParams)].filter(Boolean).join("?");
}